import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { CompanyMetrics } from '../../../types';
import { CompanyService } from '../../company.service';
import { DriversService } from '../../drivers.service';

@Component({
  selector: 'lohi-kpi',
  templateUrl: './kpi.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KpiComponent implements OnInit {
  public companyTarget$: Observable<number>;
  public companyMetrics30Day$: Observable<CompanyMetrics>;

  constructor(private driverService: DriversService, private companyService: CompanyService) {}

  public ngOnInit(): void {
    this.companyTarget$ = this.driverService.companyTarget$;
    this.companyMetrics30Day$ = this.companyService.companyMetrics30Day$;
  }
}
